<header class="sticky top-0 z-[9998] bg-white">
  <app-nav-bar></app-nav-bar>
</header>

 
    